<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-select ttRememberId="w_accountingprocessing.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-date ttLabel="date_tom" [(ttModel)]="setting.date_tom" (ttModelChange)="onChanged($event, 'date_tom')"></tt-date>
        <label [hidden]="setting.date_tom === setting.date_today" class="checklist-h2e col-xs-12">{{setting.date_not_today_warning}}</label>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
